import React, { useContext } from "react";
import ModalContext from "../../../Contexts/openModal";
import HeadingSection from "../../Pieces/HeadingSection";
import xss from "xss";
import "../../../styles/components/Slices/HeroLewitt.scss";
import SingleEmailForm2 from "../../Pieces/SingleEmailForm2";
import CustomButton from "../../CustomButton";
import { Chevron } from "../../../assets/icons";

const HeroLewitt = ({ slice, location }) => {
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;
  const { setEmail, toggleModal } = useContext(ModalContext);
  const emptyHeading = !!(
    slice?.primary?.caption_title?.text ||
    slice?.primary?.show_cta ||
    slice?.primary?.description?.text ||
    slice?.primary?.title?.text
  );
  const oneGrid = slice?.primary?.grid_layout === "1x Card";
  const twoGrid = slice?.primary?.grid_layout === "2x Card";
  const threeGrid = slice?.primary?.grid_layout === "3x Card";
  const LewittPage = location?.pathname === "/see-a-demo/" || location?.pathname === "/see-a-demo-testing/";
 

  return (
    <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
      <article
        className={` lg:mx-11 ${topSpacing === "80" ? "sm:pt-20 pt-8" : topSpacing === "40" ? "sm:pt-10 pt-8" : topSpacing === "0" ? "pt-0" : "pt-8 lg:pt-10"}  ${bottomSpacing === "80" ? "sm:pb-20 pb-8" : bottomSpacing === "40" ? "sm:pb-10 pb-8" : bottomSpacing === "0" ? "pb-0" : "pb-8 lg:pb-10"}`}
      >
        {emptyHeading && (
          <HeadingSection
            headingStyle="text-2.5xl sm:text-3.25xl text-purple-1100"
            data={slice?.primary}
            toggleModal={toggleModal}
            descriptionStyle="max-w-[890px]"
            textAreaStyle={`gap-4 ${slice?.primary?.heading_section_position === "Center" ? "heading_style_center" : "heading_style"} `}
            sectionStyle="lg:!pb-10"
          />
        )}
        <div
          className={`${twoGrid && "flex gap-4 sm:gap-6 flex-col lg:flex-row"} ${threeGrid && "grid gap-4 sm:gap-6 grid-col-1 lg:grid-cols-12 "} `}
        >
          {/* One Grid Layput */}
          {oneGrid &&
            slice?.items?.length === 1 &&
            slice?.items.map((card, index) => {
              return (
                <div
                  key={index}
                  className={`${index === 0 && "lg:col-span-5 xl:col-span-6"} rounded-[10px] min-h-0 flex flex-col lg:flex-row lg:flex-1 overflow-hidden border border-solid border-gray-1600`}
                >
                  <div className="py-10 px-4 sm:px-6 flex flex-col gap-4 sm:gap-6 bg-white lg:flex-1 lg:basis-1/2 lg:min-w-0 lg:justify-center">
                    <div
                      role="heading"
                      aria-level="2"
                      className={` text-gray-2700 text-3.25xl sm:text-4.5xl font-manrope font-medium leading-[45px] sm:leading-[60px] lg:leading-12 tracking-[-1.8px] sm:tracking-tightest_4 hero_lewitt_color_style`}
                      dangerouslySetInnerHTML={{
                        __html: xss(card?.title?.html),
                      }}
                    />
                    <p
                      className={`text-base sm:leading-7 text-gray-600 font-normal tracking-tight_1 font-inter `}
                    >
                      {card?.descriptor_text?.text}
                    </p>
                    {card?.show_email_cta && (
                      <SingleEmailForm2
                        openModal={toggleModal}
                        setEmail={setEmail}
                        buttonText={card?.cta_text?.text || "Book a demo"}
                        formHsClass={card?.hs_class?.text}
                        formId={card?.hs_id?.text}
                        containerClass="lg:!flex-none"
                      />
                    )}
                    {!card?.show_email_cta && card?.cta_text?.text && (
                      <CustomButton
                        target={card?.view_in_new_tab && "_blank"}
                        link={card?.cta_link?.url}
                        buttonClass="hidden md800:flex bg-white hover:border-gray-2500 text-gray-2500 border border-gray-2200 mx-0 whitespace-nowrap w-full lg:w-auto max-w-max group/button items-center justify-center py-2 px-4 font-semibold ease-in-out duration-500 rounded-full font-manrope tracking-tight_1 group flex"
                        text={card?.cta_text?.text}
                        icon={<Chevron />}
                        direction="right"
                        iconClass="text-gray-2500"
                      />
                    )}
                  </div>
                  <div className="lg:flex-1 lg:basis-1/2 lg:min-w-0">
                    <img
                      src={card?.card_asset?.url}
                      loading="eager"
                      alt={card?.card_asset?.alt || "ai-assistant-label"}
                      className={`h-full w-full object-cover `}
                    />
                  </div>
                </div>
              );
            })}

          {/* Two Grid Layout */}
          {twoGrid &&
            slice?.items?.length === 2 &&
            slice?.items.map((card, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    index === 0 ? "flex-col" : "flex-col-reverse"
                  } w-full rounded-[10px] min-h-0 overflow-hidden flex flex-grow bg-white border border-solid border-gray-1600`}
                >
                  {/* Wrapper for equal height */}
                  <div
                    className={`flex h-full min-h-0 ${
                      index === 0
                        ? "flex-col "
                        : "flex-col-reverse sm:flex-row-reverse lg:flex-col-reverse"
                    }`}
                  >
                    {/* Left/Top Side (Content) */}
                    <div
                      className={`${index === 0 ? "py-10 px-4 sm:px-6 gap-4 sm:gap-6" : "p-6 gap-4"} flex flex-col bg-white justify-center flex-shrink-0`}
                    >
                      {index === 0 ? (
                        <div
                          role="heading"
                          aria-level="2"
                          className={` text-gray-2700 text-3.25xl sm:text-4.5xl font-manrope font-medium leading-[45px] sm:leading-[60px] lg:leading-12 tracking-[-1.8px] sm:tracking-tightest_4 hero_lewitt_color_style`}
                          dangerouslySetInnerHTML={{
                            __html: xss(card?.title?.html),
                          }}
                        />
                      ) : (
                        <div
                          role="heading"
                          aria-level="2"
                          className={`text-2xl sm:text-2.5xl tracking-tightest_5 sm:tracking-tightest_6 font-manrope font-medium text-purple-1100 `}
                          dangerouslySetInnerHTML={{
                            __html: xss(card?.title?.html),
                          }}
                        />
                      )}

                      <p
                        className={`${index === 0 ? "text-base tracking-tight_1" : "text-sm -tracking-wider "}  font-normal sm:text-base font-inter  sm:tracking-tight_1 text-gray-2500`}
                      >
                        {card?.descriptor_text?.text}
                      </p>
                      {card?.show_email_cta && (
                        <SingleEmailForm2
                          openModal={toggleModal}
                          setEmail={setEmail}
                          buttonText={card?.cta_text?.text || "Book a demo"}
                          formHsClass={card?.hs_class?.text}
                          formId={card?.hs_id?.text}
                        />
                      )}
                      {!card?.show_email_cta && card?.cta_text?.text && (
                        <CustomButton
                          target={card?.view_in_new_tab && "_blank"}
                          link={card?.cta_link?.url}
                          text={card?.cta_text?.text}
                          icon={<Chevron />}
                          direction="right"
                          buttonClass="bg-gray-1600 hover:bg-gray-2900 text-gray-2500"
                        />
                      )}
                    </div>

                    {/* Right/Bottom Side (Image) */}
                    <div
                      className={`flex-1 min-h-0 max-h-[460px] ${"sm:min-w-[50%] lg:max-w-full"}`}
                    >
                      <img
                        src={card?.card_asset?.url}
                        loading="eager"
                        alt={card?.card_asset?.alt || "ai-assistant-label"}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              );
            })}

          {/* Three Grid Layout */}
          {threeGrid &&
            slice?.items?.length === 3 &&
            slice?.items.map((card, index) => {
              if (index === 1) {
                return (
                  <div
                    key="1-2"
                    className="lg:col-span-7 min-h-0 xl:col-span-6 flex flex-col gap-4 sm:gap-6 flex-1"
                  >
                    {[1, 2].map((i) => {
                      const card = slice.items[i];
                      return (
                        <div
                          key={i}
                          className={`${index === 0 && "lg:col-span-7 xl:col-span-6"} ${i === 1 && LewittPage ? "hidden lg:flex" : "flex"} min-h-0 flex-col sm:flex-row rounded-[10px] sm:overflow-hidden flex-1 lg:flex-1 lg:basis-1/2 lg:min-h-0 border border-solid border-gray-1600 `}
                        >
                          <img
                            src={card?.card_asset?.url}
                            loading="eager"
                            alt={card?.card_asset?.alt || "ai-assistant-label"}
                            className={`h-full sm:max-w-[50%] lg:max-w-[282px] object-cover basis-1/2 rounded-t-[10px] sm:rounded-t-none`}
                          />
                          <div className="p-4 sm:p-6 flex flex-col gap-3 bg-white justify-center flex-1 basis-1/2 min-w-0 rounded-b-[10px] sm:rounded-b-none">
                            <div
                              role="heading"
                              aria-level="2"
                              className={`text-2xl sm:text-2.5xl tracking-tightest_5 sm:tracking-tightest_6 font-manrope font-medium text-purple-1100 `}
                              dangerouslySetInnerHTML={{
                                __html: xss(card?.title?.html),
                              }}
                            />

                            <p className="text-sm font-normal sm:text-base font-inter -tracking-wider sm:tracking-tight_1 text-gray-2500">
                              {card?.descriptor_text?.text}
                            </p>
                            {card?.show_email_cta && (
                              <SingleEmailForm2
                                openModal={toggleModal}
                                setEmail={setEmail}
                                buttonText={
                                  card?.cta_text?.text || "Book a demo"
                                }
                                formHsClass={card?.hs_class?.text}
                                formId={card?.hs_id?.text}
                              />
                            )}
                            {!card?.show_email_cta && card?.cta_text?.text && (
                              <CustomButton
                                target={card?.view_in_new_tab && "_blank"}
                                link={card?.cta_link?.url}
                                text={card?.cta_text?.text}
                                icon={<Chevron />}
                                direction="right"
                                buttonClass="bg-gray-1600 hover:bg-gray-2900 text-gray-2500"
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }

              // Skip rendering index 2 because it's already handled above
              if (index === 2) return null;

              // Render all others normally
              return (
                <div
                  key={index}
                  className={`${index === 0 && "lg:col-span-5 xl:col-span-6"} rounded-[10px] overflow-hidden border border-solid min-h-0 border-gray-1600`}
                >
                  <div className="py-10 px-4 sm:px-6 flex flex-col gap-4 sm:gap-6 bg-white">
                    <div
                      role="heading"
                      aria-level="2"
                      className={` text-gray-2700 text-3.25xl sm:text-4.5xl font-manrope font-medium leading-[45px] sm:leading-[60px] lg:leading-12 tracking-[-1.8px] sm:tracking-tightest_4 hero_lewitt_color_style`}
                      dangerouslySetInnerHTML={{
                        __html: xss(card?.title?.html),
                      }}
                    />
                    <p
                      className={`text-base sm:text-lg sm:leading-7 text-gray-600 font-normal tracking-tight_1 font-inter `}
                    >
                      {card?.descriptor_text?.text}
                    </p>
                    {card?.show_email_cta && (
                      <SingleEmailForm2
                        openModal={toggleModal}
                        setEmail={setEmail}
                        buttonText={card?.cta_text?.text || "Book a demo"}
                        formHsClass={card?.hs_class?.text}
                        formId={card?.hs_id?.text}
                      />
                    )}
                    {!card?.show_email_cta && card?.cta_text?.text && (
                      <CustomButton
                        target="_blank"
                        link={card?.cta_link?.url}
                        buttonClass="hidden md800:flex bg-white hover:border-gray-2500 text-gray-2500 border border-gray-2200 mx-0 whitespace-nowrap w-full lg:w-auto max-w-max group/button items-center justify-center py-2 px-4 font-semibold ease-in-out duration-500 rounded-full font-manrope tracking-tight_1 group flex flex-shrink-0"
                        text={card?.cta_text?.text}
                        icon={<Chevron />}
                        direction="right"
                        iconClass="text-gray-2500"
                      />
                    )}
                  </div>
                  <div className="rounded-b-[10px]">
                    <img
                      src={card?.card_asset?.url}
                      loading="eager"
                      alt={card?.card_asset?.alt || "ai-assistant-label"}
                      className={`h-full w-full object-cover min-h-0 `}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </article>
    </section>
  );
};

export default HeroLewitt;
